import React, { useState } from 'react';
import Card from 'Views/Components/_HumanWritten/Card/Card';
import { Flex } from 'Views/Components/Flex/Flex';
import useStore from 'Hooks/useStore';
import {
	RegisterCustomerLocationState,
	CustomLocationState,
	isCustomerSelectionLocationState,
} from 'Models/_HumanWritten/LocationState';
import { useLocation, useNavigate } from 'react-router-dom';
import { sendActivateAccountRequest } from 'Services/Api/AccountService';
import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button';
import alertToast from 'Util/ToastifyUtils';

export interface RegisterCustomerSentProps {
	email: string;
	userId: string;
}

export function RegisterCustomerSent({ email, userId }: RegisterCustomerSentProps) {
	const navigate = useNavigate();
	const location = useLocation();

	const locationState = location.state as CustomLocationState;
	const backUrl =
		locationState && isCustomerSelectionLocationState(locationState) && locationState.backUrl
			? locationState.backUrl
			: undefined;

	const store = useStore();
	const [loading, setLoading] = useState(false);

	const onResend = async () => {
		try {
			setLoading(true);
			await sendActivateAccountRequest(email);
			setLoading(false);
		} catch (e) {
			setLoading(false);
			alertToast('Failed to send verification email', 'error');
		}
	};

	return (
		<Card className="register-customer--sent">
			<h5>Verification email sent</h5>
			<p className="body--content">
				We&apos;ve sent an email to the customer&apos;s inbox. The customer will need to verify their account to
				access the booking confirmation via the application.
				<br />
				<br />
				<strong>Didn&apos;t get an email?</strong>&nbsp; It can take a couple minutes to arrive. You can click
				below to re-send the email.
			</p>
			<Flex direction="col" gap="xs">
				<Button
					display={Display.Solid}
					colors={Colors.Primary}
					newStyles
					buttonProps={{ id: 'back_btn' }}
					onClick={() => {
						//
						// The customer tab requires the userId to auto select the newly created user.
						//
						const registerCustomerlocationState: RegisterCustomerLocationState = { userId: userId };
						navigate(backUrl ?? '/booking-wizard/Customer', { state: registerCustomerlocationState });
					}}
				>
					Back to booking
				</Button>
				<Button
					display={Display.Outline}
					colors={Colors.Secondary}
					newStyles
					buttonProps={{ id: 'resend_btn' }}
					onClick={onResend}
					disabled={loading}
				>
					{loading ? 'Sending...' : 'Resend verification email'}
				</Button>
			</Flex>
		</Card>
	);
}
